import { render, staticRenderFns } from "./selectRole.vue?vue&type=template&id=4ecf1751&scoped=true"
import script from "./selectRole.vue?vue&type=script&lang=js"
export * from "./selectRole.vue?vue&type=script&lang=js"
import style0 from "./selectRole.vue?vue&type=style&index=0&id=4ecf1751&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf1751",
  null
  
)

export default component.exports